import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Close5",
  "use": "icon-Close5-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-Close5\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.843 5.429A1 1 0 0 0 5.43 6.843l5.657 5.657-5.657 5.657a1 1 0 1 0 1.414 1.414l5.657-5.657 5.657 5.657a1 1 0 0 0 1.414-1.414L13.914 12.5l5.657-5.657a1 1 0 0 0-1.414-1.414L12.5 11.086 6.843 5.429Z\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol